var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlus2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17px",
  height: "17px",
  viewBox: "0 0 17 17",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "0A2E9541-096E-4256-A091-D5DA90395F40") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "My-Availability",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "My-Availability-2",
  transform: "translate(-326.000000, -172.000000)",
  stroke: "#8F8F8F",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy-6",
  transform: "translate(327.000000, 173.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 1.32995466e-16,
  y1: 7.08333333,
  x2: 15,
  y2: 7.08333333,
  id: "Line"
}), /*#__PURE__*/React.createElement("line", {
  x1: 7.5,
  y1: 0,
  x2: 7.5,
  y2: 15,
  id: "Path-8"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlus2);
export default ForwardRef;